
import countries from '~/assets/data/countries_all'
export default {
  layout: "blank",
  name: 'product-registration',
  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        productFamily: null,
        serial: null,
        macAddress: null,
        purchaseLocation: '',
        orderId: '',
        store: '',
        otherStore: '',
        privacyAcceptance: false,
        language: this.$i18n.locale
      },
      countries,
      productFamilies: ['Shelfy','Eteria','Natede Smart','Natede'],
      purchaseLocations: this.$t('productRegistration.purchaseLocations'),
      stores: this.$t('productRegistration.stores'),
      showSerialInstruction: false,
      showOrderInstruction: false,
      showOrderId: false,
      showStore: false,
      showOtherStore: false,
      show: false,
      formSubmitted: false,
      isLoading: false,
      showError: false
    }
  },
  head() {
    return {
      title: this.$t('productRegistration.title'),
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex' },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('productRegistration.description')
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.$t('productRegistration.keywords')
        },
      ]
    }
  },
  mounted() {
    this.loadFormData();
  },
  computed: {
    currentLocale(){
      return this.$i18n.locale
    },
    formCountries() {
      return this.countries.map(country => {
        return { value: country.code, label: country.name[this.currentLocale] }
      })
    }
  },
  watch: {
    formData: {
      handler(newFormData) {
        localStorage.setItem('productRegistrationForm', JSON.stringify(newFormData));
      },
      deep: true
    }
  },
  methods: {
    handlePurchaseLocationChange(value) {
      this.showOrderId = value === 'Ecommerce' || value === 'Amazon';
      this.showStore = value === 'Marketplace' || value === 'Retail';
      this.showOtherStore = value === 'Other' || this.formData.store === 'Other';
    },
    handleStoreChange(value) {
      this.showOtherStore = value === 'Other' || this.formData.purchaseLocation === 'Other';
    },
    loadFormData() {
      const savedFormData = localStorage.getItem('productRegistrationForm');
      if (savedFormData) {
        this.formData = JSON.parse(savedFormData);
        this.handlePurchaseLocationChange(this.formData.purchaseLocation);
      }
    },
    async validateSerial() {
      try {
        if (this.formData.serial?.length >= 11) {
          const response = await fetch(`https://gwapi.vitesy.com/api/public/verify-serial/${this.formData.serial}`,
            { headers: { 'x-api-key': process.env.PUBLIC_API_KEY }
          });
          const data = await response.json();
          if (!data.valid) {
              return false
          } else {
            this.formData.macAddress = data.mac
            return true
          }
        }
      } catch (error) {
        console.error('Error validating serial number:', error);
      }
    },
    async validateOrderId() {
      try {
          if (this.formData.purchaseLocation === 'Ecommerce' && this.formData.orderId?.length >= 8) {
            const response = await fetch(`https://gwapi.vitesy.com/api/public/verify-order/${this.formData.orderId}`,
            { headers: { 'x-api-key': process.env.PUBLIC_API_KEY }
          });
            const data = await response.json();
            if (!data.valid) {
              return false
            } else {
              this.formData.orderId = ""
              this.formData.orderId = data.id_number
              return true
            }
          } else {
            return true
          }
      } catch (error) {
        console.error('Error validating order ID:', error);
      }
    },
    async registerDevice() {
      this.isLoading = true;
      this.showError = false;
      try {
        const response = await fetch(
          `https://gwapi.vitesy.com/api/public/register-device/`,
          { 
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'x-api-key': process.env.PUBLIC_API_KEY 
            },
            body: JSON.stringify(this.formData)
          }
        );
        const data = await response.json();
        if (!data._id) {
          this.showError = true
        } else {
          console.log('Form submitted:', this.formData);
          localStorage.removeItem('productRegistrationForm'); // Clear saved data on successful submission
          this.formSubmitted = true;
        }
      } catch (error) {
        console.error('Error validating order ID:', error);
      }
      this.isLoading = false;

    }
  }
}
